<template>
  <v-card class="mb-5">
    <div class="pl-5 pr-5">
      <v-row>
        <v-col><span class="font-italic label-day">Day {{ item.courseDay }}</span></v-col>
        <v-col>{{ item.dailyEvaluation }}</v-col>
        <v-col class="text-right">
          <v-icon
            @click="handleClick()"
          >
            mdi-chevron-double-right
          </v-icon>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col><span class="font-weight-thin mt-5 label-attendance">{{ formatDate(item.courseDate) }}</span></v-col>
        <v-col><span class="font-weight-black text-h5">{{ item.bodyWeight }}</span><span class="label-small"> KG</span></v-col>
        <v-col><span class="font-weight-black text-h5">{{ item.caloriesExpended }}</span><span class="label-small">Cals</span></v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script setup>
import { ref, toRefs } from 'vue'
import { formatTime, formatDate, loading } from '@/utils/helper'

const prop = defineProps({
  item: {
    type: Object,
    default: () => ({
      id: 1,
      day: 48,
      dailyEvaluation: '加強外側肌肉(大腿)',
      attendanceDate: '12/07/2022',
      bodyWeight: 83.5,
      caloriesExpended: 2130,
    }),
  },
})
const { item } = toRefs(prop)
const emits = defineEmits(['click'])
function handleClick() {
  console.log('click')
  emits('click', item)
}
</script>
<style scoped>
.label-day{
  color:blue;
}
.value-weight{
  font-size: 20px;
}
.label-small{
  font-size: 9px;
}
.label-attendance{
  line-height: 2rem;
}
</style>
